//////////////////////////////////////////////////////////////////////////////
//
//  Advertiser API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-18
//
//  설명: 광고주 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 광고주 관련 API
 */
const AdvertiserAPI: ApiGroup = {
    pagedList: {
        title: "광고주 목록 조회",
        url: "/Advertiser/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "전체 광고주 목록 조회",
        url: "/Advertiser/List",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "광고주 상세 조회",
        url: "/Advertiser/{id}",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    create: {
        title: "광고주 등록",
        url: "/Advertiser",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "광고주 수정",
        url: "/Advertiser/{id}",
        method: "PUT",
        paramz: {},
        pathParams: ["id"],
    },
    delete: {
        title: "광고주 삭제",
        url: "/Advertiser/{id}",
        method: "DELETE",
        paramz: {},
        pathParams: ["id"],
    },
}

export default AdvertiserAPI
